var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ListItemButton, ListItemText, styled, } from '@mui/material';
import { ChevronDown16 } from '@yunex/yds-icons';
import React from 'react';
var SListItemButton = styled(ListItemButton, {
    shouldForwardProp: function (prop) { return prop !== 'overflow'; },
    name: 'MuiListItemButton',
    overridesResolver: function (_a) {
        var overflow = _a.overflow, theme = _a.theme;
        var customOverrides = theme.components.MuiListItemButton.customOverrides;
        return [customOverrides.topNavItem, overflow && customOverrides.topNavItemOverflow];
    },
})({
    minWidth: 'auto',
});
var TopNavItem = function (_a) {
    var overflow = _a.overflow, children = _a.children, props = __rest(_a, ["overflow", "children"]);
    return (React.createElement(SListItemButton, __assign({}, __assign({ overflow: overflow }, props)),
        React.createElement(ListItemText, null, children),
        overflow && React.createElement(ChevronDown16, null)));
};
export default TopNavItem;
